<template>
    <div id="forgetPassword">
        <div style="height: 250px; text-align: center">
            <van-image :src="require('@/assets/image/common/logo.png')" width="200px" style="margin-top: 30px;"></van-image>
        </div>

        <van-form @submit="onSubmit">
            <van-field
                    v-model="loginFrom.telephone"
                    type="phone"
                    :name="langText.phoneNumber"
                    :label="langText.phoneNumber"
                    :placeholder="langText.phoneNumber"
                    :rules="[{ required: true, message: langText.phoneMessage }]"
            />

            <van-field
                    v-model="loginFrom.authCode"
                    type="code"
                    :name="langText.messageCode"
                    :label="langText.messageCode"
                    :placeholder="langText.messageCode"
                    :rules="[{ required: true, message: langText.messageCodeHint }]">

                <van-button slot="button" native-type="button" size="small" type="primary" @click="getcode" :disabled="disabled" >
                    {{langText.sendCode}}
                    <span v-if="this.num != 60 ">
                        ({{num}})
                    </span>
                </van-button>
            </van-field>

            <van-field
                    v-model="loginFrom.password"
                    type="password"
                    :name="langText.password"
                    :label="langText.password"
                    :placeholder="langText.password"
                    :rules="[{ required: true, message: langText.passwordMessage }]"
            />

            <van-field
                    v-model="loginFrom.passwordbool"
                    type="password"
                    :name="langText.confirmPassword"
                    :label="langText.confirmPassword"
                    :placeholder="langText.confirmPassword"
                    :rules="[{ required: true, message: langText.confirmPasswordMessage }]"
            />

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    <span style="font-size: 16px;">{{langText.submitPasswordChange}}</span>
                </van-button>
            </div>

            <div style="padding:10px 16px">
                <span @click="toLogin" style="color: #999999">
                    << {{langText.returnLogin}}
                </span>
            </div>

        </van-form>
    </div>
</template>

<script>
    import { Form, Field, Button, Image, Toast } from 'vant';
    import {updatePassword} from "@/network/login/login";
    import {getCodeTelephone} from "@/network/login/login";
    import { langPackage } from "@/config/lang/loginLang";
    export default {
        name: "ForgetPassword",
        components: {
            [ Form.name ]: Form,
            [ Field.name ]: Field,
            [ Button.name ]: Button,
            [ Image.name ]: Image
        },
        data() {
            return{
                loginFrom: {    //表单数据
                    bool:null,
                    telephone:'',
                },
                disabled:false,
                num:60,
                timer:"",
                lang:"cn",
                langText:{}
            }
        },
        methods: {
            onSubmit() {
                //判断两次的密码是否正确
                let From = this.loginFrom;
                if (From.password != From.passwordbool && From.passwordbool){
                    Toast('两次输入的密码有误');
                    return false
                }
                //弹窗显示
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
                //延迟提交
                setTimeout(() => {
                    updatePassword(this.loginFrom).then(() => {
                        Toast.clear();
                        this.$router.push({path:'/index/login', query: {lang: this.lang}})
                    }).catch(err => {
                        Toast.clear();
                        Toast(err);
                    })
                }, 1000)
            },
            toLogin(){
                this.$router.push({path:'/index/login', query: {lang: this.lang}})
            },
            getcode(){ //获取验证码
                if (this.loginFrom.telephone == ''){
                    Toast('请输入手机号码!')
                    return false;
                }
                if(this.loginFrom.telephone.length != 11){
                    Toast('请输入正确的手机号码!')
                    return false;
                }
                getCodeTelephone(this.loginFrom.telephone).then((res)=>{
                    //设置禁止按钮
                    this.disabled = true;
                    Toast('验证码发送成功')
                    this.disabledfun()
                })
            },
            disabledfun(){
                this.timer = setInterval(this.addnum, 1000);
            },
            addnum(){//设置计时器
                if (this.num == 0){
                    this.num = 60;
                    this.disabled = false;
                    clearInterval(this.timer);
                    return true;
                }
                this.num--;
            },
            getLangText(){
                if(this.$route.query.lang != "" && this.$route.query.lang != undefined){
                    this.lang = this.$route.query.lang;
                }

                if (this.lang == "cn"){
                    this.langText = langPackage.cn;
                }
                if (this.lang == "en"){
                    this.langText = langPackage.en;
                }
                //
            }

        },
        created() {
           this.getLangText();
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/login.css";

</style>
